// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","group":"group-1VDRp","group__label":"group__label-E0MOT"};